export const DESCRIPTION_DEFAULT = "Easy deployment of open-source web apps and custom solutions for IT, SMEs. Deploy to Hetzner Cloud, Amazon EC2, Digital Ocean, Alibaba Cloud, and more.";
